// Centralized backend URL resolver
// Priority: explicit env -> valid URL -> fallback to same-origin

export function resolveBackendUrl(){
  const envUrl = (process.env.REACT_APP_BACKEND_URL || import.meta?.env?.REACT_APP_BACKEND_URL || '').trim();
  const invalid = !envUrl || /none\.preview|undefined|null|^https?:\/\/$/i.test(envUrl);
  let base = envUrl;
  if (invalid) {
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      if (origin && /^https?:\/\//i.test(origin)) base = origin;
    } catch {}
  }
  return base;
}
